// Mirrors the attempt color scheme used on the existing /admin/diploma-batch-phases
// (DiplomaResults.jsx attemptColors()) page, so this report's phase cells look
// consistent with where the marks are actually edited.
export function attemptBadgeClass(attempt) {
  if (attempt === '2nd attempt') return 'bg-amber-100 text-amber-800 border border-amber-200';
  if (attempt === '3rd attempt') return 'bg-red-100 text-red-800 border border-red-200';
  return 'bg-green-100 text-green-800 border border-green-200';
}

export function attemptLabelClass(attempt) {
  if (attempt === '2nd attempt') return 'text-amber-600';
  if (attempt === '3rd attempt') return 'text-red-500';
  return 'text-green-600';
}

export function attemptLabel(attempt) {
  if (attempt === '2nd attempt') return '2nd';
  if (attempt === '3rd attempt') return '3rd';
  if (attempt === '1st attempt') return '1st';
  return null;
}

export function formatMarks(marks) {
  return marks === null || marks === undefined ? '—' : String(marks);
}
